import React from 'react';
import Navbar from '../Components/Navbar/Navbar';
import '../Styles/Blogs.css'
const Blogs = () => {
    return (
        <div>
            <Navbar bgColor={"#fff"} textColor={'#000'} />
            <div style={{ marginTop: "59.5px" }} className="blogs__container">
                <div className="blog">
                    <img src="#" alt="" />
                    <p>Coming Soon</p>
                </div>
            </div>
        </div>
    );
};

export default Blogs;